import { gql } from '@apollo/client';

export const ALGORITHM_VERSIONS_PAGE_GQL = gql`
  query AlgorithmVersionsPageQuery {
    algorithm(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
      version
      description
      published_at
      barn_algorithm_overrides(where: { deleted_at: { _is_null: true } }) {
        barn {
          id
          name
        }
      }
      device_algorithm_overrides(where: { deleted_at: { _is_null: true } }) {
        device {
          id
          serial
        }
      }
    }
  }
`;
